<!-- Main container with custom theme branding -->
<div class="custom-theme-branding" ngClass="p-l">
	<!-- Close button aligned to the top right -->
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button mat-icon-button (click)="onCloseClick()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<!-- Main content layout -->
	<div
		fxLayout="row"
		fxLayout.xs="column"
		fxLayout.lt-sm="column"
		fxLayout.lt-md="column"
		fxLayoutGap="5%"
	>
		<!-- Left column for selection and content -->
		<div fxLayout="column" fxFlex="55%">
			<div fxLayout="column">
				<div fxLayout="column">
					<span i18n="@@share_dialog_step1"> Step 1 </span>
					<h2 i18n="@@share_dialog_select_what_to_share">
						Select what you want to share
					</h2>
				</div>

				<!-- Dropdown to select what to share -->
				<mat-form-field appearance="outline">
					<mat-label for="select-option">Select option</mat-label>
					<mat-select
						id="select-option"
						[(value)]="selectedPanel"
						(selectionChange)="selectPanel($event.value)"
					>
						<mat-option value="fundraiser">{{ fundraiserLabel }}</mat-option>
						<mat-option value="donate">{{ donationLabel }}</mat-option>
						<mat-option value="paymentRequest">{{
							paymentRequestLabel
						}}</mat-option>
						<mat-option value="ownWebsite">{{ ownWebsiteLabel }}</mat-option>
					</mat-select>
				</mat-form-field>

				<!-- Step 2: Select where to share -->
				<div
					*ngIf="selectedPanel !== 'paymentRequest'"
					fxLayout="column"
					ngClass="p-t-s"
				>
					<span i18n="@@share_dialog_step2"> Step 2 </span>
					<h2
						*ngIf="selectedPanel != 'ownWebsite'"
						i18n="@@share_dialog_select_where_to_share"
					>
						Select where you want to share
					</h2>
				</div>
			</div>

			<!-- Conditional content based on selected panel -->
			<div *ngIf="selectedPanel === 'fundraiser'">
				<app-share-fundraiser-page
					[type]="'fundraiser'"
					[disablePayment]="false"
				></app-share-fundraiser-page>
			</div>

			<div *ngIf="selectedPanel === 'donate'">
				<app-share-fundraiser-page
					[type]="'donate'"
					[disablePayment]="false"
				></app-share-fundraiser-page>
			</div>

			<div *ngIf="selectedPanel === 'paymentRequest'" ngClass="p-t-s">
				<app-payment-request
					[selectedFundraiser]="data.fundraiser"
					[componentCalled]="'share-dialog'"
				></app-payment-request>
			</div>

			<div *ngIf="selectedPanel === 'ownWebsite'" ngClass="p-t-s">
				<app-embed
					[slug]="data.fundraiser?.slug"
					[selectedFundraiser]="data.fundraiser"
					[amountProgressData]="data"
					[profileResponse]="profileResponse"
				></app-embed>
			</div>
		</div>

		<!-- Right column for preview -->
		<div fxLayout="column" fxFlex="40%">
			<app-share-preview
				[type]="selectedPanel"
				[amountProgressData]="data"
				[slug]="slug"
			></app-share-preview>
		</div>
	</div>
</div>
